import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  platform: string;
  rating: number;
  year: number;
  updateInfo: string;
  imageUrl: string;
  url: string;
  size?: 'default' | 'small' | 'large';
}

export default function VideoCard({ title, category, platform, rating, year, updateInfo, imageUrl, url, size = 'default' }: VideoCardProps) {
  const aspectClass = size === 'large' ? 'aspect-video' : 'aspect-[16/10]';

  return (
    <Link to={url} className="group block cursor-pointer">
      <div className={`relative ${aspectClass} rounded-lg overflow-hidden mb-3 bg-background-200`}>
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          title={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-3 left-3">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
            {category}
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <span className="px-2 py-0.5 bg-black/50 backdrop-blur-sm text-white text-xs rounded-md whitespace-nowrap">
            {rating}
          </span>
        </div>
        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
          <span className="text-white text-xs bg-black/40 backdrop-blur-sm px-2 py-0.5 rounded-md whitespace-nowrap">
            {platform}
          </span>
          <span className="text-white text-xs whitespace-nowrap">
            {updateInfo}
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 backdrop-blur-sm">
            <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
        {title}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-foreground-500">{year}</span>
        <span className="text-xs text-foreground-400">·</span>
        <span className="text-xs text-foreground-500">{updateInfo}</span>
      </div>
    </Link>
  );
}